import { DataTableCollapsibleRow, Loader } from "@/components"
import { Button } from "@/components/ui";
import useNormalView from "./useNormalView";
import { AddEditTask } from "../Task";

const NormalView = () => {
  const {
    isPlanLoading,
    taskColumns,
    isTaskLoading,
    taskListData,
    onRowClick,
    taskData,
    isTaskExist,
    taskList,
    isView,
    onAddNewTask,
  } = useNormalView();
  
  return isPlanLoading || isTaskLoading ? <Loader /> : 
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
    <div className="lg:col-span-2 bg-white rounded-lg shadow-sm overflow-hidden max-h-[calc(100vh-150px)] overflow-y-scroll">
      <DataTableCollapsibleRow 
        data={taskListData}
        columns={taskColumns}
        className="shadow-none border-0"
        onRowClick={onRowClick}
      />
    </div>
    <div className="bg-white rounded-lg shadow-sm">
      <div className="flex flex-row items-center justify-between px-4 py-3 border-b-[0.5px] mb-3">
        <h4 className={"font-[600] text-[16px] text-start"}>
          {isView ?
            `View ${taskData?.taskName || ''} Detail` : taskData ? `Edit ${taskData?.taskName || ''} Detail` 
            : 'Add Task'}
        </h4>
        {isView ? <></> : <Button onClick={onAddNewTask}>Add New</Button>}
      </div>
      {/* <hr /> */}
      <AddEditTask isTaskExist={isTaskExist} taskList={taskList} />
    </div>
  </div>
}

export default NormalView;